// src/store/useAuthStore.ts
import {create} from "zustand";
import {supportedLanguages} from "../services/systemService.ts";
import {SupportedLanguagesDto} from "../models/interfaces/dtos/supportedLanguages.dto.interace.ts";

interface ISystemState {
  supportedCodeLanguages: string[];
  getSupportedLanguages: () => Promise<void>;
}

const useSystemStore = create<ISystemState>((set) => ({
  supportedCodeLanguages: [] as string[],
  getSupportedLanguages: async (): Promise<void> => {
    try {
      const supportedLanguagesDto: SupportedLanguagesDto[] = await supportedLanguages();
      const supportedCodeLanguages: string[] = supportedLanguagesDto
        .filter((langDto: SupportedLanguagesDto) => langDto.code != "en_uk")
        .map((langDto: SupportedLanguagesDto) => langDto.code);
      set(() => ({supportedCodeLanguages: supportedCodeLanguages}));
    } catch (error) {
      console.error("Error fetching supported languages:", error);
      throw error;
    }
  }
}));


export default useSystemStore;
